/* Wild Crop page CTA analytics v2.0.0. Existing GA4 and Shopify consent only. */
(function () {
  'use strict';
  if (!/^\/pages\/[^/]+\/?$/.test(location.pathname) || window.__wcPageCtaTracking) return;
  window.__wcPageCtaTracking = true;
  // Retire the previous page-only listener if an old deferred reference is still cached.
  window.__wcAmazonCtaTracking = true;
  var PATH = location.pathname.replace(/\/$/, ''), GA = 'G-8JQBJ7KZ1W';
  var legacy = PATH === '/pages/surspark-anxiety';
  var test = new URLSearchParams(location.search).get('wc_tracking_test') === '1';
  var ready = false, landed = false, clicks = 0, maxScroll = 0, active = 0, since = null;
  var viewId = null, summarySent = false, entries = [], seen = Object.create(null), observer, timer;
  var selector = 'main a[href], .epo-sticky-buy a[href]';
  function allowed() {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed() === true); }
    catch (_) { return false; }
  }
  function enabled() { return allowed() && typeof window.gtag === 'function'; }
  function safeCode(s) { return typeof s === 'string' && /^[a-z0-9_-]{1,80}$/i.test(s) ? s : ''; }
  function source() {
    var p = new URLSearchParams(location.search), out = {};
    ['source', 'medium', 'campaign', 'content'].forEach(function (k) {
      var value = safeCode(p.get('utm_' + k)); if (value) out['traffic_' + k] = value;
    });
    return out;
  }
  function referrer() { try { return document.referrer ? new URL(document.referrer).origin : ''; } catch (_) { return ''; } }
  function pause() { if (since !== null) active += performance.now() - since; since = null; }
  function elapsed() { return Math.max(0, Math.round((active + (since === null ? 0 : performance.now() - since)) / 1000)); }
  function scroll() {
    if (allowed()) maxScroll = Math.max(maxScroll, Math.min(100, Math.round((scrollY + innerHeight) / Math.max(document.documentElement.scrollHeight, 1) * 100)));
  }
  function reset() { pause(); active = 0; viewId = null; landed = false; clicks = 0; maxScroll = 0; summarySent = false; seen = Object.create(null); }
  function classify(a) {
    try {
      var raw = a.getAttribute('href') || '', url = new URL(a.href), kind, slot, asin = '';
      if (!/^https?:$/.test(url.protocol) || !a.closest('main, .epo-sticky-buy')) return null;
      if (/(^|\.)amazon\.com$/.test(url.hostname) || url.hostname === 'amzn.to') {
        kind = 'amazon';
        slot = a.matches('.discount-btn') ? 'top' : a.closest('.epo-sticky-buy') ? 'sticky' : a.matches('.epo-cta-amazon') ? 'inline' : /^shop now$/i.test(a.textContent.trim()) ? 'secondary' : 'main';
        var match = url.pathname.match(/\/(?:dp|gp\/product)\/([A-Z0-9]{10})(?:\/|$)/i); asin = match ? match[1].toUpperCase() : '';
      } else {
        if (!a.matches('.button,[class*="btn"],[class*="button"],[class*="cta"],.wc-shop,[class*="product-card"],.wc-pairing__image,[role="button"]')) return null;
        if (raw.charAt(0) === '#' || (url.origin === location.origin && url.pathname === location.pathname && url.hash)) { kind = 'anchor'; slot = 'purchase_anchor'; }
        else if (url.origin === location.origin) { kind = 'store'; slot = a.matches('.wc-pairing__image,[class*="product-card"]') ? 'product_card' : 'shop_now'; }
        else { kind = 'outbound'; slot = 'external'; }
      }
      // Strip query data from non-Amazon destinations. Amazon attribution parameters remain exact.
      var target = kind === 'amazon' ? a.href : url.origin + url.pathname + url.hash;
      return {kind: kind, slot: slot, target: target, domain: url.hostname, asin: asin};
    } catch (_) { return null; }
  }
  function discover() {
    var counters = Object.create(null);
    document.querySelectorAll(selector).forEach(function (a) {
      var found = classify(a); if (!found) return;
      var base = found.kind + '_' + found.slot;
      counters[base] = (counters[base] || 0) + 1;
      var id = base + (counters[base] > 1 ? '_' + counters[base] : '');
      var current = entries.find(function (e) { return e.anchor === a; });
      if (!current) {
        while (entries.some(function (e) { return e.id === id; })) { counters[base] += 1; id = base + '_' + counters[base]; }
        current = {anchor: a, id: id}; entries.push(current);
        a.setAttribute('data-wc-cta-id', id);
        if (observer) observer.observe(a);
      }
      current.info = found;
    });
  }
  function eventName(entry, action) {
    return entry.info.kind === 'amazon' ? 'amazon_' + entry.info.slot + '_' + action :
      entry.info.kind === 'anchor' ? 'page_anchor_' + action :
      entry.info.kind === 'store' ? 'store_cta_' + action : 'outbound_cta_' + action;
  }
  function details(entry) {
    return {button_id: entry.id, button_position: entry.info.slot, button_kind: entry.info.kind,
      button_text: entry.anchor.textContent.replace(/\s+/g, ' ').trim().slice(0, 80),
      link_url: entry.info.target, link_domain: entry.info.domain, product_asin: entry.info.asin};
  }
  function emit(name, extra) {
    if (!enabled()) return false;
    if (!viewId) viewId = crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
    var data = Object.assign({send_to: GA, page_location: location.origin + PATH, page_referrer: referrer(),
      page_title: legacy ? 'Surspark landing page' : 'Wild Crop landing page', page_view_id: viewId,
      time_on_page_seconds: elapsed(), scroll_depth_percent: maxScroll, clicked_any: clicks ? 1 : 0,
      click_count: clicks, visitor_language: String(navigator.language || '').slice(0, 20), tracking_version: '2.0.0'}, source(), extra || {});
    if (test) { name += '_test'; data.debug_mode = true; }
    try { window.gtag('event', name, data); return true; } catch (_) { return false; }
  }
  function visible(e) {
    var r = e.anchor.getBoundingClientRect(), style = getComputedStyle(e.anchor);
    var w = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0));
    var h = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
    return r.width > 0 && r.height > 0 && w * h >= r.width * r.height * 0.5 && style.visibility !== 'hidden' && style.display !== 'none';
  }
  function expose(e) { if (!seen[e.id] && visible(e) && emit(eventName(e, 'view'), details(e))) seen[e.id] = true; }
  function reconcile() {
    if (!allowed()) { reset(); return; }
    if (!ready || !enabled()) return;
    discover(); if (!entries.length) return;
    if (document.visibilityState !== 'visible') return;
    if (since === null) since = performance.now(); scroll();
    if (!landed && emit(legacy ? 'amazon_landing_view' : 'page_cta_landing_view')) landed = true;
    if (!observer && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (changes) {
        if (!enabled() || document.visibilityState !== 'visible') return;
        changes.forEach(function (change) { if (change.isIntersecting && change.intersectionRatio >= 0.5) {
          var e = entries.find(function (item) { return item.anchor === change.target; }); if (e) expose(e);
        } });
      }, {threshold: [0.5]});
      entries.forEach(function (e) { observer.observe(e.anchor); });
    }
    entries.forEach(expose);
  }
  function click(event) {
    if (!event.isTrusted || (event.type === 'auxclick' && event.button !== 1) || !enabled()) return;
    var a = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!a || !classify(a)) return;
    reconcile(); discover();
    var e = entries.find(function (item) { return item.anchor === a; }); if (!e) return;
    e.info = classify(a); scroll(); clicks += 1; summarySent = false;
    emit(eventName(e, 'click'), Object.assign(details(e), {click_method: event.type === 'auxclick' ? 'middle_click' : event.detail === 0 ? 'keyboard' : 'pointer'}));
    // Native navigation remains untouched: no preventDefault, redirect, or navigation timeout.
  }
  document.addEventListener('click', click, true);
  document.addEventListener('auxclick', click, true);
  document.addEventListener('visitorConsentCollected', reconcile);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') pause(); else reconcile(); });
  window.addEventListener('scroll', scroll, {passive: true});
  window.addEventListener('pagehide', function () { pause(); scroll(); if (landed && !summarySent && emit(legacy ? 'amazon_landing_summary' : 'page_cta_summary')) summarySent = true; });
  window.addEventListener('pageshow', function (event) { if (event.persisted) { summarySent = false; reconcile(); } });
  document.addEventListener('shopify:section:load', reconcile);
  function start() {
    ready = true; discover(); reconcile();
    var main = document.querySelector('main'), pending;
    if (main && 'MutationObserver' in window) new MutationObserver(function (changes) {
      if (!changes.some(function (change) { return Array.from(change.addedNodes).concat(Array.from(change.removedNodes)).some(function (node) { return node.nodeType === 1; }); })) return;
      clearTimeout(pending); pending = setTimeout(function () { discover(); reconcile(); }, 150);
    }).observe(main, {childList: true, subtree: true});
    if (window.Shopify && Shopify.loadFeatures && !Shopify.customerPrivacy) Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) { if (!error) reconcile(); });
    var tries = 0; timer = setInterval(function () { reconcile(); if (enabled() || ++tries >= 40) clearInterval(timer); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();
